module.exports = __webpack_public_path__ + "img/is.2d4bc19a.svg";